import { A4 } from 'components/shared/print'
import AppendixLow from 'api/../../public/result_v2/subscription_appendix_low.jpg'
import AppendixMidHigh from 'api/../../public/result_v2/subscription_appendix_mid_high.jpg'
import { Sample } from 'entities/sample'
import { QRCodeSVG } from 'qrcode.react'
import { WITH_TAX_RATE } from 'utils/util'
import moment from 'moment'
import { useInputCouponApi, useProductsApi } from 'api/coupon'
import { useEffect, useMemo } from 'react'
import { Coupon } from 'entities/coupon'

type Props = {
    sample: Sample
}

export const DEFAULT_UPSELLING_SUBSCRIPTION_COUPON_CODE = 'sus573924752'
export const ResultSubscriptionAppendix = ({ sample }: Props) => {
    const isHomeTest = !!process.env.REACT_APP_IS_HOME_TEST
    const isOnlyLowScore = sample.results && sample.results.every((r) => r.resultLevel === '低')

    const env = process.env.REACT_APP_ENV
    const inputCouponApi = useInputCouponApi()
    const productsApi = useProductsApi()
    const customerOrder = sample?.requestForm?.customerOrder

    useEffect(() => {
        inputCouponApi.execute(DEFAULT_UPSELLING_SUBSCRIPTION_COUPON_CODE)
        productsApi.execute()
    }, [])

    const scanProduct = useMemo(() => {
        console.log(productsApi.response.products)
        return productsApi.response.products?.find((product) => product.category === 'scan' && !product.is_campaign_product)
    }, [productsApi.response])
    console.log(scanProduct)

    /**
     * 定期アップセルなどで、入力クーポンと定期クーポンを同時に適用する場合の価格計算
     */
    const calculatePriceExcludeCampaign = () => {
        if (!scanProduct) return 0
        let priceWithTax = (scanProduct?.price ?? 0) * WITH_TAX_RATE

        const getDiscount = (coupon?: Coupon) => {
            if (coupon?.discountPrice) {
                return coupon.discountPrice
            } else if (coupon?.discountRate) {
                const originalPriceWithTax = (scanProduct?.price ?? 0) * WITH_TAX_RATE
                return Math.round(originalPriceWithTax * coupon.discountRate)
            }
            return 0
        }

        if (scanProduct?.subscriptionCoupon) {
            priceWithTax -= getDiscount(scanProduct.subscriptionCoupon)
        }

        if (inputCouponApi.response?.purchaseProductCategories?.includes(scanProduct?.category)) {
            priceWithTax -= getDiscount(inputCouponApi.response)
        }
        return priceWithTax
    }

    const domain = env === 'production' ? 'misignal.jp' : 'localhost:3004'
    const url = `http://${domain}/mypage/v2/results/scan/${sample.code}/upgrade_subscription`
    const baseDate = sample.sendDate ? moment(sample.sendDate) : moment()
    const expiredDate = baseDate.add(14, 'days').format('YYYY年MM月DD日')

    if (customerOrder?.ecSubscription || customerOrder?.membershipPlan) return null
    if (sample?.results && sample.results.length < 5) return null
    if (!isHomeTest) return null
    return (
        <>
            <A4 padding={0} landscape={false}>
                <div className="page-root">
                    <img src={isOnlyLowScore ? AppendixLow : AppendixMidHigh} style={{ objectFit: 'contain', width: '100%' }} />

                    <div
                        style={{
                            position: 'absolute',
                            bottom: 171,
                            left: 222,
                            color: '#FBFBA0',
                            textAlign: 'center',
                            fontFamily: 'Noto Sans JP',
                            fontSize: 21.28,
                            fontStyle: 'normal',
                            fontWeight: '700',
                            lineHeight: '138%',
                            letterSpacing: '0.638px',
                            width: 400,
                        }}
                    >
                        {expiredDate}
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            bottom: 85,
                            right: 201,
                            color: '#FF865B',
                            fontFamily: 'Noto Sans JP',
                            fontSize: '24px',
                            fontStyle: 'normal',
                            fontWeight: '700',
                            lineHeight: '175%',
                            letterSpacing: '-0.239px',
                        }}
                    >
                        {Math.round(calculatePriceExcludeCampaign())?.toLocaleString()}
                        <span
                            style={{
                                fontSize: 13.3,
                                fontStyle: 'normal',
                                letterSpacing: '-0.133px',
                            }}
                        >
                            円〜
                        </span>
                    </div>

                    <div
                        style={{
                            position: 'absolute',
                            bottom: 65,
                            right: 73,
                        }}
                        onClick={() => {
                            window.open(url, '_blank')
                        }}
                    >
                        <QRCodeSVG value={url} size={70} />
                    </div>
                </div>
            </A4>
            <A4 padding={0} landscape={false}>
                {/* 冊子になるように白紙のページを挿入 */}
            </A4>
        </>
    )
}
